import { render, staticRenderFns } from "./Narrative.vue?vue&type=template&id=cc21f9f8&"
import script from "./Narrative.vue?vue&type=script&lang=js&"
export * from "./Narrative.vue?vue&type=script&lang=js&"
import style0 from "./Narrative.vue?vue&type=style&index=0&id=cc21f9f8&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports